import { render } from "./VabeneAddTimeSlot.vue?vue&type=template&id=3272bf20&ts=true"
import script from "./VabeneAddTimeSlot.vue?vue&type=script&lang=ts"
export * from "./VabeneAddTimeSlot.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__